module.exports = __webpack_public_path__ + "img/fwdx.9bd17f75.png";